import { createRoot } from "react-dom/client";
import React from 'react';
import ReactDOM from 'react-dom';
import 'mapbox-gl/dist/mapbox-gl.css';
import './index.css';
import App from './App';

const root = createRoot(document.getElementById('approot'));

root.render(<React.StrictMode>
<App />
</React.StrictMode>);